import $axios from './api';

export const list = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/publication/list', payload);
	return data;
};

export const create = async ( payload ) => {
	const { data } = await $axios.post('/v1/author/publication/create', payload);
	return data;
};

export const getById = async (id) => {
	const { data } = await $axios.get(`/v1/author/publication/${id}`);
	return data;
};

export const edit = async ( { publicationId, payload } ) => {
	const { data } = await $axios.post(`/v1/author/publication/${publicationId}`, payload);
	return data;
};

export const unpublish = async (publicationId) => {
	const { data } = await $axios.post(`/v1/author/publication/${publicationId}/unpublish`);
	return data;
};

export const publish = async (publicationId) => {
	const { data } = await $axios.post(`/v1/author/publication/${publicationId}/publish`);
	return data;
};

export const requestApproval = async (publicationId) => {
	const { data } = await $axios.post(`/v1/author/publication/${publicationId}/requestApproval`);
	return data;
};

export const deletePublication = async (publicationId) => {
	const { data } = await $axios.delete(`/v1/author/publication/${publicationId}`);
	return data;
};

export const clearRejection = async (publicationId) => {
	const { data } = await $axios.post(`/v1/author/publication/${publicationId}/clearRejection`);
	return data;
};

export const archive = async (publicationId) => {
	const { data } = await $axios.post(`/v1/author/publication/${publicationId}/archive`);
	return data;
};

export const canArchive = async (publicationId) => {
	const { data } = await $axios.post(`/v1/author/publication/${publicationId}/canArchive`);
	return data;
};